import { useState } from 'react';

import { usePortfolioHistory, HistoryTab } from '@/app/components/PortfolioPageComponents/hooks/usePortfolioHistory';
import { useUserPortfolio } from '@/app/components/PortfolioPageComponents/hooks/useUserPortfolio';
import PortfolioHistoryTable from '@/app/components/PortfolioPageComponents/PortfolioHistoryTable';
import PortfolioPageContainer from '@/app/components/PortfolioPageComponents/PortfolioPageContainer';
import PortfolioPositionsTable from '@/app/components/PortfolioPageComponents/PortfolioPositionsTable';
import PortfolioWithdrawalsTable from '@/app/components/PortfolioPageComponents/PortfolioWithdrawalsTable';
import { HISTORY_TABS } from '@/app/shared/constants/portfolio';
import { Tabs } from '@/app/shared/ui/Tabs';

const PortfolioStatsPage = () => {
  const [historyTab, setHistoryTab] = useState<HistoryTab>('all');
  const { currentValueUsd, depositedUsd, yieldEarnedUsd, apy, isLoading } = useUserPortfolio();
  const { count: historyCount } = usePortfolioHistory('all');

  const stats = [
    { label: 'Total portfolio value', value: isLoading ? '-' : currentValueUsd },
    { label: 'Total deposited', value: isLoading ? '-' : depositedUsd },
    { label: 'Yield earned', value: isLoading ? '-' : yieldEarnedUsd },
    { label: 'Current weighted APY', value: isLoading ? '-' : apy },
  ];

  return (
    <PortfolioPageContainer
      stats={stats}
      topSection={
        <div className='flex h-full flex-col justify-end gap-3 px-5 pb-[42px] min-[1300px]:px-10'>
          <h1 className='text-2xl font-normal text-brand-1100 md:text-[30px]'>Portfolio</h1>
          <p className='max-w-xl text-base leading-6 text-gray-400'>
            Positions remain separated by vault so the terms and performance of one strategy are never presented as
            applying to another.
          </p>
        </div>
      }
      mainSection={
        <>
          <PortfolioPositionsTable />
          <PortfolioWithdrawalsTable />
          <div className='flex flex-col gap-3'>
            <h2 className='text-base font-normal text-brand-1100'>Transaction history</h2>
            <div className='flex flex-col gap-3 min-[960px]:flex-row min-[960px]:items-start min-[960px]:justify-between'>
              <p className='text-base leading-6 text-gray-400'>
                Deposits, tranche receipts, yield, fees and withdrawal activity.
              </p>
              <span className='shrink-0 text-base leading-6 text-gray-400'>
                {historyCount} {historyCount === 1 ? 'transaction' : 'transactions'}
              </span>
            </div>
          </div>
          <div className='relative'>
            <div className='pointer-events-none absolute right-0 bottom-0 left-0 border-b border-decoration-stroke xl:right-[calc(-1*(100vw-46px-100%)/2)] xl:left-[calc(-1*(100vw-46px-100%)/2)]' />
            <Tabs
              tabs={HISTORY_TABS}
              activeTab={historyTab}
              onTabChange={setHistoryTab}
              className='flex items-end gap-5'
              tabClassName='-mb-px border-b-2 border-transparent pb-5 text-base leading-5 transition-colors'
              activeTabClassName='border-brand-1100 text-brand-1100'
              inactiveTabClassName='text-gray-400 hover:text-gray-50'
            />
          </div>
          <PortfolioHistoryTable activeTab={historyTab} />
        </>
      }
    />
  );
};

export default PortfolioStatsPage;
